import React, { useState } from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import Close from 'public/assets/svg/close.svg'

const styleSheet = () => ({
    container: {
        position: 'fixed',
        top: 0,
        height: '50px',
        width: '100%',
        backgroundColor: 'black',
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        backgroundColor: 'black',
        opacity: '0.85',
        zIndex: 10000,
    },
    bannerText: {
        color: 'white',
    },
    closeBtn: {
        background: 'none',
        outline: 'none',
        padding: 0,
        border: 0,
        top: '3px',
        position: 'relative',
    },
})

const style = injectJss(styleSheet)

const IOSBadVersionBanner = ({ classes }) => {
    const [showBanner, setShowBanner] = useState(true)
    const bannerText = 'Please update to the latest version of iOS for the best experience.'
    return (
        showBanner && (
            <div className={classes.container}>
                <div className={classes.bannerText}>{bannerText}</div>
                <button onClick={() => setShowBanner(!showBanner)} type="button" className={classes.closeBtn}>
                    <img src={Close} />
                </button>
            </div>
        )
    )
}

export default compose(style)(IOSBadVersionBanner)
